import { useCategories } from "../../../lib/firebase/category/read";
import { Link } from "react-router-dom";

export default function CategoriesListView() {
    const { data, error, isLoading } = useCategories();

    if (isLoading) {
        return <h1 className="text-center mt-4">Loading...</h1>;
    }

    if (error) {
        return <h1 className="text-center text-danger mt-4">{error}</h1>;
    }

    if (!data || data.length === 0) {
        return <h1 className="text-center text-warning mt-4">No categories found!</h1>;
    }

    return (
        <section className="container mt-4">
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead className="table-primary text-center">
                        <tr>
                            <th scope="col">Sr.</th>
                            <th scope="col">Icon</th>
                            <th scope="col">Name</th>
                            <th scope="col">Slug</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={item.id} className="text-center align-middle">
                                <td>{index + 1}</td>
                                <td>
                                    <img
                                        src={item.iconURL}
                                        alt="Category Icon"
                                        className="img-fluid rounded"
                                        style={{ height: "40px" }}
                                    />
                                </td>
                                <td>{item.name}</td>
                                <td>{item.slug}</td>
                                <td>
                                    <Link to={`/admin/categories/form?id=${item.id}`}>
                                        <button className="btn btn-sm btn-primary">Edit</button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
